import * as React from "react";
import { QuoteFilterBy } from "kw/api/zeus";
import { useAPI } from "kw/api/useAPI";
import { $ } from "kw/api";

type TUpdateReferralPendingCountContext = Record<string, unknown>;

export const buildUpdateReferredPendingCount = (
  context: TUpdateReferralPendingCountContext,
  dependencies: React.DependencyList
) => {
  const {
    referredPendingCount,
    setReferredPendingCount,
    claimsAllowed,
    setClaimsAllowed,
  } = context;
  const { query } = useAPI();

  return React.useCallback(() => {
    const search = "";
    const filterBy = QuoteFilterBy.REFERRED_PENDING;
    const page = 1;

    query(
      {
        admin: {
          quotes: [
            {
              search: $("search", "String!"),
              filterBy: $("filterBy", "QuoteFilterBy!"),
              page: $("page", "Int!"),
            },
            {
              totalItemCount: true,
            },
          ],
          claimsAllowed: true,
        },
      },
      (response: { admin: { quotes: TAdminQuotes; claimsAllowed: boolean } }) => {
        const count = response.admin.quotes.totalItemCount;
        if (referredPendingCount != count) {
          setReferredPendingCount(count);
        }
        if (claimsAllowed != response.admin.claimsAllowed) {
          setClaimsAllowed(response.admin.claimsAllowed);
        }
      },
      {
        search,
        filterBy,
        page,
      }
    );
  }, dependencies);
};

type TUpdateClaimsAllowedContext = Record<string, unknown>;

export const buildUpdateClaimsAllowed = (
  context: TUpdateClaimsAllowedContext,
  dependencies: React.DependencyList
) => {
  const { claimsAllowed, setClaimsAllowed } = context;
  const { query } = useAPI();

  return React.useCallback(() => {
    query(
      {
        claimsAllowed: true,
      },
      (response: { claimsAllowed: boolean }) => {
        const result = response.claimsAllowed;
        if (claimsAllowed != result) {
          setClaimsAllowed(result);
        }
      }
    );
  }, dependencies);
};
